var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformationSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.1776 0 0 7.1776 0 16C0 24.8224 7.1776 32 16 32C24.8224 32 32 24.8224 32 16C32 7.1776 24.8224 0 16 0ZM17.2 23.6C17.2 24.2624 16.6624 24.8 16 24.8C15.3376 24.8 14.8 24.2624 14.8 23.6V14.8C14.8 14.1376 15.3376 13.6 16 13.6C16.6624 13.6 17.2 14.1376 17.2 14.8V23.6ZM16 11.2C15.116 11.2 14.4 10.484 14.4 9.6C14.4 8.716 15.116 8 16 8C16.884 8 17.6 8.716 17.6 9.6C17.6 10.484 16.884 11.2 16 11.2Z",
    fill: "#2C4657"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationSvg);
export default __webpack_public_path__ + "static/media/information-svg.15d15315022744ab04b15f107fa00a47.svg";
export { ForwardRef as ReactComponent };